/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 182);
/******/ })
/************************************************************************/
/******/ ({

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(183);
module.exports = __webpack_require__(185);


/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hand_img_png__ = __webpack_require__(184);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _window$Liftoff = window.Liftoff,
    Component = _window$Liftoff.Component,
    DOMUtils = _window$Liftoff.DOMUtils,
    Utils = _window$Liftoff.Utils;


var TEMPLATE = "<div class=\"hand-component\">\n  <div class=\"cue\">\n    <img class=\"hand\" src=\"\"/>\n  </div>\n</div>";

var animations = {
  tap: "click-animate",
  "swipe left": "left-animate",
  "swipe right": "right-animate",
  "swipe up": "up-animate",
  "swipe down": "down-animate"
};

Component.register("hand-component", function (_Component) {
  _inherits(Counter, _Component);

  function Counter(config) {
    _classCallCheck(this, Counter);

    var _this = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this, config));

    Object.assign(_this, Utils.mergePropertiesWithDefaults({
      handStyle: null,
      clickInterval: 1000,
      customHandImage: null
    }, Utils.selectKeys(_this.config, function (_, val) {
      return val != null;
    })));
    return _this;
  }

  _createClass(Counter, [{
    key: "load",
    value: function load() {
      var promises = [Utils.loadImages([this.config.customHandImage])];
      return Promise.all(promises);
    }
  }, {
    key: "layout",
    value: function layout(parentNode) {
      this.el = DOMUtils.strToElement(TEMPLATE);
      this.handEl = this.el.querySelector(".cue > .hand");
      this._initializeLayout();

      // Render main component layout.
      _get(Counter.prototype.__proto__ || Object.getPrototypeOf(Counter.prototype), "layout", this).call(this, parentNode);
      this.parentNode.appendChild(this.el);

      this._initializeEvents();
    }
  }, {
    key: "_initializeLayout",
    value: function _initializeLayout() {
      var _this2 = this;

      // Inicialize hand image.
      this.handEl.src = this.config.customHandImage || __WEBPACK_IMPORTED_MODULE_0__hand_img_png__["a" /* default */];

      // Initialize style.
      Object.assign(this.handEl.style, this.config.handStyle);

      this.handEl.classList.add(animations[this.config.animation]);

      // Restart animations.
      if (this.config.clickInterval) {
        setInterval(function () {
          _this2.handEl.classList.remove(animations[_this2.config.animation]);
          _this2.el.getClientRects(); // Small trick to start dom reflow.

          // Add new
          _this2.handEl.classList.add(animations[_this2.config.animation]);
        }, this.config.clickInterval);
      }
    }
  }, {
    key: "_initializeEvents",
    value: function _initializeEvents() {
      var _this3 = this;

      DOMUtils.on(this.el.closest("#liftoff-layout"), {
        "mouseup touchend click": function mouseupTouchendClick() {
          _this3._hide();
        }
      });
    }
  }, {
    key: "_hide",
    value: function _hide() {
      this.el.style.display = "none";
    }
  }, {
    key: "start",
    value: function start() {
      _get(Counter.prototype.__proto__ || Object.getPrototypeOf(Counter.prototype), "start", this).call(this);
    }
  }, {
    key: "stop",
    value: function stop() {
      _get(Counter.prototype.__proto__ || Object.getPrototypeOf(Counter.prototype), "stop", this).call(this);
      this._hide();
    }
  }, {
    key: "restart",
    value: function restart() {
      _get(Counter.prototype.__proto__ || Object.getPrototypeOf(Counter.prototype), "restart", this).call(this);
    }
  }, {
    key: "resize",
    value: function resize() {
      _get(Counter.prototype.__proto__ || Object.getPrototypeOf(Counter.prototype), "resize", this).call(this);
    }
  }]);

  return Counter;
}(Component));

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var handImageData = "data:image/png;base64,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";

/* harmony default export */ __webpack_exports__["a"] = (handImageData);

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// hand-component.js